import { CategoryKeys, QuestionsKeys } from 'help/types/types'

import type { ActiveOrderType } from '../../types/activePurchases.types'
import { OrderStatus, StatusLines } from '../../types/purchases.types'
import { purchaseStatusInfo } from '../purchaseStatusInfo/purchaseStatusInfo'

export const getPurchaseQuestionsIds = ({
	lastOrder,
}: {
	lastOrder: ActiveOrderType
}) => {
	const outOfStock = lastOrder.lines.find(
		(order) => order.status === StatusLines.outOfStock
	)
	if (outOfStock && lastOrder.status === OrderStatus.in_preparation) {
		return [
			{
				categoryKey: CategoryKeys.delivery,
				questionKey: QuestionsKeys.orderIncomplete,
			},
			{
				categoryKey: CategoryKeys.returns,
				questionKey: QuestionsKeys.refunds,
			},
			{
				categoryKey: CategoryKeys.loyalty,
				questionKey: QuestionsKeys.checkLikes,
			},
		]
	}
	return purchaseStatusInfo[lastOrder.status].questions
}
